/**
 * 本文件由 scripts/generate-spm-codes.mjs 生成，请勿手改；编码以评审确认后的 CSV 快照为准。
 * 全局终端：global_pc（由 CSV 页面终端行派生，B 位重写为 global_pc；213 个 D 位坑位，11 个 C 位模块）。
 * 数据源：home_pc（header_tools、primary_navigation、site_notice、site_settings、footer_navigation、footer_help、footer_country_sites、footer_policies、footer_social、footer_subscribe）、product_detail_pc（breadcrumb）。
 * 模块级曝光上报 module.code（A.B.C）；坑位级曝光与点击上报完整编码（A.B.C.D）。
 */
import type { SpmPageCodes } from '../types';
import { getSpmSitePrefix } from '../site';

const sitePrefix = getSpmSitePrefix();

export const GLOBAL_PC_SPM_CODES = {
  breadcrumb: {
    code: `${sitePrefix}.global_pc.breadcrumb`,
    'breadcrumb_item_{NN}': `${sitePrefix}.global_pc.breadcrumb.breadcrumb_item_{NN}`,
  },
  footer_country_sites: {
    code: `${sitePrefix}.global_pc.footer_country_sites`,
    'country_site_entry_{NNN}': `${sitePrefix}.global_pc.footer_country_sites.country_site_entry_{NNN}`,
  },
  footer_help: {
    code: `${sitePrefix}.global_pc.footer_help`,
    open_contact_us: `${sitePrefix}.global_pc.footer_help.open_contact_us`,
    open_market_zeelool_com: `${sitePrefix}.global_pc.footer_help.open_market_zeelool_com`,
    open_track_order: `${sitePrefix}.global_pc.footer_help.open_track_order`,
  },
  footer_navigation: {
    code: `${sitePrefix}.global_pc.footer_navigation`,
    'footer_link_{NN}': `${sitePrefix}.global_pc.footer_navigation.footer_link_{NN}`,
  },
  footer_policies: {
    code: `${sitePrefix}.global_pc.footer_policies`,
    'policy_entry_{NN}': `${sitePrefix}.global_pc.footer_policies.policy_entry_{NN}`,
  },
  footer_social: {
    code: `${sitePrefix}.global_pc.footer_social`,
    'social_entry_{NN}': `${sitePrefix}.global_pc.footer_social.social_entry_{NN}`,
  },
  footer_subscribe: {
    code: `${sitePrefix}.global_pc.footer_subscribe`,
    email_input: `${sitePrefix}.global_pc.footer_subscribe.email_input`,
    submit_subscription: `${sitePrefix}.global_pc.footer_subscribe.submit_subscription`,
  },
  header_tools: {
    code: `${sitePrefix}.global_pc.header_tools`,
    cart_entry: `${sitePrefix}.global_pc.header_tools.cart_entry`,
    open_account: `${sitePrefix}.global_pc.header_tools.open_account`,
    open_wishlist: `${sitePrefix}.global_pc.header_tools.open_wishlist`,
    search_input: `${sitePrefix}.global_pc.header_tools.search_input`,
    search_submit: `${sitePrefix}.global_pc.header_tools.search_submit`,
  },
  primary_navigation: {
    code: `${sitePrefix}.global_pc.primary_navigation`,
    logo_entry: `${sitePrefix}.global_pc.primary_navigation.logo_entry`,
    'nav_item_{NN}': `${sitePrefix}.global_pc.primary_navigation.nav_item_{NN}`,
    scroll_navigation_next: `${sitePrefix}.global_pc.primary_navigation.scroll_navigation_next`,
    scroll_navigation_previous: `${sitePrefix}.global_pc.primary_navigation.scroll_navigation_previous`,
    'submenu_item_{NN}_{NN}': `${sitePrefix}.global_pc.primary_navigation.submenu_item_{NN}_{NN}`,
  },
  site_notice: {
    code: `${sitePrefix}.global_pc.site_notice`,
    open_help_center: `${sitePrefix}.global_pc.site_notice.open_help_center`,
    open_promotion: `${sitePrefix}.global_pc.site_notice.open_promotion`,
    open_site_settings: `${sitePrefix}.global_pc.site_notice.open_site_settings`,
    track_order: `${sitePrefix}.global_pc.site_notice.track_order`,
  },
  site_settings: {
    code: `${sitePrefix}.global_pc.site_settings`,
    'country_option_{NNN}': `${sitePrefix}.global_pc.site_settings.country_option_{NNN}`,
    country_selector: `${sitePrefix}.global_pc.site_settings.country_selector`,
    'currency_option_{NN}': `${sitePrefix}.global_pc.site_settings.currency_option_{NN}`,
    currency_selector: `${sitePrefix}.global_pc.site_settings.currency_selector`,
    'language_option_{NN}': `${sitePrefix}.global_pc.site_settings.language_option_{NN}`,
    language_selector: `${sitePrefix}.global_pc.site_settings.language_selector`,
  },
} as const satisfies SpmPageCodes;
